import * as React from "react";
function SvgDoctor(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 13.005v6h8v-6h-8zm-2 7V13h-.21A3.79 3.79 0 005 16.79H3A5.79 5.79 0 018.79 11h1.594v.005H20a1 1 0 011 1v8a1 1 0 01-1 1H10a1 1 0 01-1-1zM10 6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm2 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm1 10.255h1.25v1.25h1.5v-1.25H17v-1.5h-1.25v-1.25h-1.5v1.25H13v1.5zm1-5.75c0-.66.09-.907.13-.98a.98.98 0 01.154-.02c.124-.008.236-.006.385-.003a17.884 17.884 0 00.661 0c.15-.003.262-.005.386.003a.98.98 0 01.155.02c.039.073.129.32.129.98h2c0-1.146-.214-2.155-1.06-2.679-.386-.238-.793-.298-1.1-.317-.201-.013-.446-.009-.643-.006a13.924 13.924 0 01-.394 0c-.197-.003-.442-.007-.644.006-.306.02-.714.079-1.1.317C12.215 8.85 12 9.86 12 11.006h2zm.147-1.007l-.006.007.006-.007zm1.706 0l.006.007-.006-.007z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgDoctor);
export default ForwardRef;
